export const TIMEZONE_OFFSET = '+03:00'

export const PAGINATION_LIMIT = 200
export const TASK_PAGINATION_LIMIT = 15
export const BRANDS_PAGINATION_LIMIT = 10
export const CDN_STATS_LIMIT = 5
export const CDN_MD5_LIFE_TIME = 600 // 10min

export const S3_MIN_FILE_SIZE_MULTIPART_UPLOAD = 500 * 1024 * 1024 // 500 MB
export const S3_PART_SIZE_MULTIPART_UPLOAD = 10 * 1024 * 1024 // 10 MB
export const S3_MAX_QUEUE_SIZE = 4
export const S3_MAX_KEYS_LIMIT = 200
export const S3_POLICY_VERSION = process.env.VUE_APP_S3_POLICY_VERSION
export const S3_BUCKET_STATS_INTERVAL = Number(process.env.VUE_APP_S3_BUCKET_STATS_INTERVAL) * 1000
export const SERVER_TIME_TO_UNIX_MS_COEFFICIENT = 1 // milliseconds

export const timezones = [
  // Гавайско-Алеутское время
  { value: 'Hawaii-Aleutian (-10)', abbr: 'HAST' },
  { value: 'Alaska (-9)', abbr: 'AKST' },
  { value: 'Alaska Daylight Time (-8)', abbr: 'AKDT' },

  // Северная Америка
  { value: 'Pacific Standard Time (-8)', abbr: 'PST' },
  { value: 'Pacific Daylight Time (-7)', abbr: 'PDT' },
  { value: 'Mountain Standard Time (-7)', abbr: 'MST' },
  { value: 'Mountain Daylight Time (-6)', abbr: 'MDT' },
  { value: 'Central Standard Time (-6)', abbr: 'CST' },
  { value: 'Central Daylight Time (-5)', abbr: 'CDT' },
  { value: 'Eastern Standard Time (-5)', abbr: 'EST' },
  { value: 'Eastern Daylight Time (-4)', abbr: 'EDT' },

  // Атлантический регион
  { value: 'Atlantic Standard Time (-4)', abbr: 'AST' },
  { value: 'Atlantic Daylight Time (-3)', abbr: 'ADT' },
  { value: 'Newfoundland Standard Time (-3.5)', abbr: 'NST' },
  { value: 'Newfoundland Daylight Time (-2.5)', abbr: 'NDT' },

  // Южная Америка
  { value: 'Brazil Time (-3)', abbr: 'BRT' },
  { value: 'Argentina Time (-3)', abbr: 'ART' },
  { value: 'Greenland Time (-3)', abbr: 'WGT' },

  // Атлантика и Европа
  { value: 'Mid-Atlantic Time (-2)', abbr: 'MAT' },
  { value: 'Azores Time (-1)', abbr: 'AZOT' },
  { value: 'Cape Verde Time (-1)', abbr: 'CVT' },
  { value: 'Coordinated Universal Time (0)', abbr: 'UTC' },
  { value: 'Greenwich Mean Time (0)', abbr: 'GMT' },
  { value: 'British Summer Time (+1)', abbr: 'BST' },
  { value: 'Central European Time (+1)', abbr: 'CET' },
  { value: 'Central European Summer Time (+2)', abbr: 'CEST' },
  { value: 'Eastern European Time (+2)', abbr: 'EET' },
  { value: 'Eastern European Summer Time (+3)', abbr: 'EEST' },

  // Россия (временные зоны и города)
  { value: 'Kaliningrad Time (+2) - Калининград', abbr: 'KALT' },
  { value: 'Moscow Time (+3) - Москва, Санкт-Петербург', abbr: 'MSK' },
  { value: 'Samara Time (+4) - Самара, Саратов', abbr: 'SAMT' },
  { value: 'Yekaterinburg Time (+5) - Екатеринбург', abbr: 'YEKT' },
  { value: 'Omsk Time (+6) - Омск', abbr: 'OMST' },
  { value: 'Krasnoyarsk Time (+7) - Красноярск', abbr: 'KRAT' },
  { value: 'Irkutsk Time (+8) - Иркутск', abbr: 'IRKT' },
  { value: 'Yakutsk Time (+9) - Якутск', abbr: 'YAKT' },
  { value: 'Vladivostok Time (+10) - Владивосток', abbr: 'VLAT' },
  { value: 'Magadan Time (+11) - Магадан', abbr: 'MAGT' },
  { value: 'Kamchatka Time (+12) - Петропавловск-Камчатский', abbr: 'PETT' },

  // Азия
  { value: 'Iran Standard Time (+3.5)', abbr: 'IRST' },
  { value: 'Gulf Standard Time (+4)', abbr: 'GST' },
  { value: 'Pakistan Standard Time (+5)', abbr: 'PKT' },
  { value: 'Indian Standard Time (+5.5)', abbr: 'IST' },
  { value: 'Nepal Standard Time (+5.75)', abbr: 'NPT' },
  { value: 'Bangladesh Standard Time (+6)', abbr: 'BDT' },
  { value: 'Myanmar Time (+6.5)', abbr: 'MMT' },
  { value: 'Indochina Time (+7)', abbr: 'ICT' },
  { value: 'China Standard Time (+8)', abbr: 'CST' },
  { value: 'Japan Standard Time (+9)', abbr: 'JST' },
  { value: 'Korea Standard Time (+9)', abbr: 'KST' },
  { value: 'Australian Central Standard Time (+9.5)', abbr: 'ACST' },
  { value: 'Australian Eastern Standard Time (+10)', abbr: 'AEST' },
  { value: 'Lord Howe Standard Time (+10.5)', abbr: 'LHST' },

  // Тихоокеанский регион
  { value: 'New Zealand Standard Time (+12)', abbr: 'NZST' },
  { value: 'Fiji Time (+12)', abbr: 'FJT' },
  { value: 'Kamchatka Time (+12)', abbr: 'PETT' },
  { value: 'Chatham Islands Time (+12.75)', abbr: 'CHAST' },
  { value: 'Tonga Time (+13)', abbr: 'TOT' }
]

/**
 * Закомментированные экшены еще не протестированы
 */
export const s3ActionsOptions = [
  { value: 's3:*', label: 'S3:*' },
  { value: 's3:AbortMultipartUpload', label: 'AbortMultipartUpload' },
  { value: 's3:DeleteBucketPolicy', label: 'DeleteBucketPolicy' },
  { value: 's3:DeleteObject', label: 'DeleteObject' },
  { value: 's3:GetBucketAcl', label: 'GetBucketAcl' },
  { value: 's3:GetBucketLocation', label: 'GetBucketLocation' },
  // { value: 's3:GetBucketNotification', label: 'GetBucketNotification' },
  { value: 's3:GetBucketPolicy', label: 'GetBucketPolicy' },
  // { value: 's3:GetBucketVersioning', label: 'GetBucketVersioning' },
  { value: 's3:GetBucketWebsite', label: 'GetBucketWebsite' },
  // { value: 's3:GetEncryptionConfiguration', label: 'GetEncryptionConfiguration' },
  // { value: 's3:GetLifecycleConfiguration', label: 'GetLifecycleConfiguration' },
  { value: 's3:GetObject', label: 'GetObject' },
  { value: 's3:GetObjectAcl', label: 'GetObjectAcl' },
  { value: 's3:HeadBucket', label: 'HeadBucket' },
  { value: 's3:HeadObject', label: 'HeadObject' },
  { value: 's3:ListBucket', label: 'ListBucket' },
  { value: 's3:ListBucketMultipartUploads', label: 'ListBucketMultipartUploads' },
  { value: 's3:ListMultipartUploadParts', label: 'ListMultipartUploadParts' },
  // { value: 's3:ListenBucketNotification', label: 'ListenBucketNotification' },
  { value: 's3:PutBucketAcl', label: 'PutBucketAcl' },
  { value: 's3:PutBucketLocation', label: 'PutBucketLocation' },
  { value: 's3:PutBucketPolicy', label: 'PutBucketPolicy' },
  // { value: 's3:PutBucketNotification', label: 'PutBucketNotification' },
  // { value: 's3:PutBucketVersioning', label: 'PutBucketVersioning' },
  { value: 's3:PutBucketWebsite', label: 'PutBucketWebsite' },
  // { value: 's3:PutEncryptionConfiguration', label: 'PutEncryptionConfiguration' },
  { value: 's3:PutObject', label: 'PutObject' }
]
